export default __webpack_public_path__ + "static/media/button_upload_th.83db3395.svg";